import React, { useState, useContext, useRef, useEffect } from "react";
import ReactPlayer from "react-player";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import CTFLIXLoading from "../assets/svg/ctflix-loading.svg";
import AppContext from "../context/AppContext";

const CTFLIXPlay = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [playing, setPlaying] = useState(false); // Estado para play/pause
    const [volume, setVolume] = useState(0.5); // Estado para el volumen
    const [showSidebar, setShowSidebar] = useState(false); // Estado para mostrar sidebar de anotaciones
    const [showVolumen, setShowVolumen] = useState(false); // Estado para mostrar sidebar de anotaciones
    const [currentTime, setCurrentTime] = useState(0); // Estado para tiempo actual del video
    const [duration, setDuration] = useState(0); // Duración del video
    const playerRef = useRef(null); // Referencia al ReactPlayer
    const [preloading, setLoading] = useState(true); // Estado para manejar el cargador
    const { loading, updateLoading, play } = useContext(AppContext);
    // Función llamada cuando el video está listo
    const handleReady = () => {
        setLoading(false); // El video está listo, ocultamos el cargador
    };

    // Función llamada cuando el video empieza a cargar (en buffering)
    const handleBuffer = () => {
        setLoading(true); // El video está en buffer, mostramos el cargador
    };
    // Controlar el tiempo de reproducción
    const handleProgress = (progress) => {
        setCurrentTime(progress.playedSeconds);
    };

    const handleDuration = (duration) => {
        setDuration(duration);
    };

    const togglePlay = () => {
        setPlaying(prev => !prev);
    };

    const handleSeek = (seconds) => {
        playerRef.current.seekTo(seconds);
    };


    const toggleSidebar = () => {
        setShowSidebar(prev => !prev);
    };

    const toggleVolumen = () => {
        setShowVolumen(prev => !prev);
    };


    const handleVolumeChange = (event) => {
        setVolume(event.target.value);
    };

    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            // Entra en modo de pantalla completa
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) { // Firefox
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) { // Safari y Chrome
                document.documentElement.webkitRequestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
                document.documentElement.msRequestFullscreen();
            }
        } else {
            // Sale del modo de pantalla completa
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { // Safari y Chrome
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { // IE/Edge
                document.msExitFullscreen();
            }
        }
    };

    const goBack = () => {
        handleBeforeUnload()
        navigate(-1); // Retrocede a la página anterior en el historial
    };

    const handleBeforeUnload = () => {
        if (currentTime <= 0) {
            return;
        }
        const formData = new FormData();
        formData.append('ctflix', play?.id);
        formData.append('duration', duration);
        formData.append('currentTime', currentTime);
        fetch(`${process.env.REACT_APP_BACKEND}/ctflix-play`, {
            method: "POST",
            headers: {
                Authorization: `${localStorage.getItem("token")}`,
            },
            body: formData,
        })
            .then((response) => response.json())
            .then((response) => {
                console.log("Video data saved successfully:", response);
            })
            .catch((error) => {
                console.error("Error saving video data:", error);
            });
    }

    useEffect(() => {
        window.addEventListener('beforeunload', handleBeforeUnload);
        // Limpiar el event listener cuando el componente se desmonte
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [currentTime, duration]);

    return (
        <>
            <div className="relative w-full h-screen bg-black">
                {/* Fondo oscuro */}
                <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50"></div>

                {preloading && (
                    <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50">
                        <img
                            src={CTFLIXLoading} // Cambia esta URL por tu imagen de cargador
                            alt="Cargando..."
                            width="100%"
                            height="100%"
                        />
                    </div>
                )}

                {/* Reproductor de video */}
                <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
                    <ReactPlayer
                        ref={playerRef}
                        url={play ? play?.vimeo : "https://vimeo.com/1062614603/d83d94a5ae"}
                        playing={playing}
                        width="100%"
                        height="100%"
                        onProgress={handleProgress} // Actualizar el tiempo de reproducción
                        onDuration={handleDuration} // Guardar la duración del video
                        onReady={handleReady} // Cuando el video está listo
                        onBuffer={handleBuffer} // Cuando el video está en buffering
                        volume={volume} // Controlar el volumen
                        onPlay={() => setPlaying(true)} // Cambiar estado a playing
                        onPause={() => setPlaying(false)} // Cambiar estado a pause
                    />
                </div>


                <>

                    {/* Controles Superior */}
                    <div className="absolute top-10 left-6 right-6 flex justify-between items-center text-white">
                        {/* Botón de retroceso */}
                        <button onClick={() => goBack()} className="bg-transparent p-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                            </svg>
                        </button>

                        {/* Icono de bandera que abrirá el sidebar */}
                        <button onClick={toggleSidebar} className="bg-transparent p-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
                            </svg>
                        </button>
                    </div>

                    {/* Barra de progreso */}
                    <div className="absolute bottom-16 left-6 right-6 flex justify-between items-center text-white">
                        <input
                            type="range"
                            min="0"
                            max={duration}
                            step="0"
                            value={currentTime}
                            onChange={(e) => handleSeek(parseFloat(e.target.value))}
                            className="slider-play w-full mx-2"
                        />
                    </div>
                    {/* Controles personalizados */}
                    <div className="absolute bottom-10 left-6 right-6 flex justify-between items-center justify-center text-white">
                        <div>
                            {/* Botón de play/pause */}
                            <button onClick={togglePlay} className="bg-transparent p-2">
                                {playing ?
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
                                    </svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
                                    </svg>
                                }
                            </button>
                            {/* Botón de retroceso */}
                            <button onClick={() => handleSeek(currentTime - 10)} className="bg-transparent p-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                                </svg>
                            </button>
                            <button onClick={() => handleSeek(currentTime + 10)} className="bg-transparent p-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m15 15 6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3" />
                                </svg>
                            </button>
                        </div>
                        <h2 className="text-xl font-semibold lg:block hidden">{play ? play?.name : "CTFLIX"}</h2>
                        <h2 className="text-xl font-semibold lg:hidden block">CTX </h2>
                        <div>
                            {/* Volumen */}
                            <button onClick={toggleVolumen} className="bg-transparent p-2 ">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" />
                                </svg>
                            </button>
                            {/* Botón de pantalla completa */}
                            <button onClick={toggleFullscreen} className="bg-transparent p-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
                                </svg>
                            </button>

                            {/* Icono de bandera que abrirá el sidebar */}
                            <button onClick={toggleSidebar} className="bg-transparent p-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/** Barra de Sonido */}
                    {!showVolumen && (
                        <div className=" bottom-7 right-40 flex justify-between items-center justify-center text-white lg:absolute hidden">
                            <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.01"
                                value={volume}
                                onChange={handleVolumeChange}
                                className="w-24"
                            />
                        </div>
                    )}
                </>

                {/* Sidebar de anotaciones */}
                {showSidebar && (
                    <div className="absolute top-0 right-0 w-full lg:w-1/3 h-full sheim-green bg-gray-800 text-white p-6">
                        <div className="flex flex-row gap-2 items-center">
                            <button onClick={toggleSidebar} className="bg-transparent p-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg>
                            </button>
                            <h3 className="text-2xl ">Tools</h3>
                        </div>
                        <p className="text-lg">{play?.description}</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default CTFLIXPlay;
